module.exports = __webpack_public_path__ + "img/icon-exchange.2700ca74.svg";